import Loading from '../../../Common/Loading';
import { Method } from './Method';
import { MothersLessThan7ConsutationsPrenatal } from './MothersLessThan7ConsutationsPrenatal';
import { OccurenceLocation } from './OccurenceLocation';
import { PreNatalConsultations } from './PreNatalConsultations';
import { PregnanciesWeeks } from './PregnanciesWeeks';
import { PregnancyTypes } from './PregnancyTypes';
import { PrenatalStartMonth } from './PrenatalStartMonth';
import { TypesOfBirthsOnPreviosPregnancies } from './TypesOfBirthsOnPreviosPregnancies';
import { useCurrentPregnancyChartsDataContext } from './hooks/useCurrentPregnancyChartsDataContext';

export const Charts = () => {
    const { isLoading } = useCurrentPregnancyChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="w-100">
                <MothersLessThan7ConsutationsPrenatal />
            </div>
            <div className="charts-side-by-side-dashboards">
                <PregnanciesWeeks />
                <PreNatalConsultations />
            </div>
            <div className="charts-side-by-side-dashboards">
                <Method />
                <TypesOfBirthsOnPreviosPregnancies />
                <PregnancyTypes />
            </div>
            <div className="charts-side-by-side-dashboards">
                <OccurenceLocation />
                <PrenatalStartMonth />
            </div>
        </>
    );
};
